import { useCallback, useEffect, useState } from 'react'

import API from '@api/client'
import { CategoryEdition } from '@models/Category'
import environment from 'config/environment'

export function useCategories() {
  const [categories, setCategories] = useState<CategoryEdition[]>([])
  const [archives, setArchives] = useState<CategoryEdition[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | undefined>()

  const fetchCategories = useCallback(async () => {
    setIsLoading(true)
    setError(undefined)
    try {
      const requests = [API.getCategories()]
      if (environment.isDev) {
        requests.push(API.getCategories({ includeInactive: true }))
      }

      const [activeResult, archivesResult] = await Promise.all(requests)
      setCategories(Array.isArray(activeResult.data) ? activeResult.data : [])
      setArchives(
        environment.isDev && archivesResult && Array.isArray(archivesResult.data)
          ? archivesResult.data
          : [],
      )
    } catch (err) {
      setError((err as { message?: string })?.message ?? 'Unknown error')
      setCategories([])
      setArchives([])
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    void fetchCategories()
  }, [fetchCategories])

  return { categories, archives, isLoading, error, refetch: fetchCategories }
}
